import { createReducer, on } from '@ngrx/store';
import { notifyQuotationFinish } from './afterQuotation.actions';

export interface State {
  wasFinished: boolean;
}

export const initialState = {
  wasFinished: false,
};

export const afterQuotationReducer = createReducer(
  initialState,
  on(notifyQuotationFinish, (state, { wasFinished }) => ({
    ...state,
    wasFinished,
  }))
);
